import React from "react";

export type Course = {
  id: string;
  title: string;
  location: string;
  category: string;
  shortDescription: string;
  startDate: string;
  duration: string;
  imageUrl?: string;
  pageContent?: string;
  registrationEmail?: string;
  hidden?: boolean;
};

export default function CourseCard({ course, onRegister }: { course: Course; onRegister: (c: Course) => void }) {
  const imageUrl = course.imageUrl ? encodeURI(course.imageUrl) : "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";

  return (
    <div className="card cursor-pointer group h-full flex flex-col overflow-hidden" onClick={() => onRegister(course)}>
      <div className="relative h-48 w-full overflow-hidden flex-shrink-0">
        <img
          src={imageUrl}
          alt={course.title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity" />
        <div className="absolute bottom-3 left-4 right-4 flex items-center justify-between gap-2">
          <span className="rounded-full bg-white/90 px-3 py-1 text-xs font-medium text-slate-700 shadow">
            {course.location}
          </span>
        </div>
      </div>
      <div className="p-5 flex-grow flex flex-col">
        <div className="mb-2 flex justify-center">
          <span className="badge">{course.category}</span>
        </div>
        <h3 className="text-lg font-semibold text-slate-900 group-hover:text-violet-600 transition-colors">
          {course.title}
        </h3>
        <p className="text-sm text-slate-600 flex-grow mt-2 mb-4">
          {course.shortDescription}
        </p>
        <div className="pt-3 border-t border-slate-200 flex flex-col gap-2 text-sm text-slate-500 mt-auto">
          <div className="flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
            <span>{course.startDate}</span>
          </div>
          <div className="flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            <span>Duración: {course.duration}</span>
          </div>
        </div>
        <button
          className="mt-4 btn-primary w-full"
          onClick={(e) => {
            e.stopPropagation();
            onRegister(course);
          }}
        >
          ¡Inscríbete!
        </button>
      </div>
    </div>
  );
}
